/*
@Description: 公告管理
@Author: xiaozengtongxue
@Date: 2024-02-02 10:50:32
*/
<template>
  <div class="moMenuBox">
    <div class="userInfoBox">
      <div class="tips">
        <img src="../../assets/images/head.png" alt="祝你开心每一天！" />
        <h3>{{ welcomeSrc }}祝你开心每一天！</h3>
      </div>
      <div class="numBox">
        <div class="numLeft numContent">
          <p>工厂数量</p>
          <h3>{{ listC }}</h3>
        </div>
        <div class="numLeft numContent">
          <p>配方数量</p>
          <h3>{{ formulaCount }}</h3>
        </div>
        <div class="numContent">
          <p>产品数量</p>
          <h3>{{ productCount }}</h3>
        </div>
      </div>
    </div>

    <div class="tableBox">
      <div style="margin-bottom: 10px">
        <a-button @click="jump">返回</a-button>
      </div>
      <a-table
        ref="listRef"
        row-key="id"
        :columns="columns"
        :data-source="list"
        :pagination="pagination"
        bordered
      >
        <div slot="noticeTitle" slot-scope="text, record" class="nv">
          <a v-if="record.content" target="_blank" :href="record.content">
            {{ text }}</a
          >
          <span v-else>{{ text }}</span>
        </div>
      </a-table>
    </div>
  </div>
</template>
<script>
import moment from "moment";
import { columns } from './Columns'
export default {
  data() {
    return {
      userName: '',
      listC: 0,
      formulaCount: 0,
      productCount: 0,
      columns,
      list: [],
      welcomeSrc: '',
      clientInfo: {},
      pagination: {
        total: 0,
        pageSize: 20,
        current: 1,
        showSizeChanger: true,
        showTotal: (total) => `总共${total}个类目`,
        onChange: (current, pageSize) => {
          this.pagination.current = current
          this.getList({ current, pageSize })
        },//选择页数
        onShowSizeChange: (current, pageSize) => {
          this.pagination.pageSize = pageSize
          this.pagination.current = 1
          this.getList({ current: 1, pageSize })
        } //每页多少条
      },
    };
  },
  created() {
    let accessToken = window.localStorage.getItem("accessToken");
    let refreshToken = window.localStorage.getItem("refreshToken");
    if (accessToken && refreshToken) {
      this.getFactory();
      this.getUserInfo();
      setTimeout(() => {
        let user = window.localStorage.getItem('userInfo')
        // this.userInfo = this.setUserInfo(user)
        if (user) {
          this.$track.sendTrack('login', {
            userInfo: this.setUserInfo(JSON.parse(user))
          })
        }
      }, 1000);
    } else {
      this.$router.push("/login");
    }
  },
  mounted() {
    // this.dealBtnList(this.menuBtnList)
    this.getClient()
  },
  methods: {
    async getClientList(pagination) {
      let { current = 1, pageSize = 20 } = pagination || this.pagination
      let params = {
        current,
        size: pageSize,
        clientId: this.clientInfo.id
      }
      let res = await this.$get('/iot-factory/basicNotice/page', params)
      let { success, data } = res || {}
      if (success) {
        let { records, current = 1, total = 0 } = data;
        this.pagination.current = current
        this.pagination.total = total
        this.list = records || []
      }
    },
    async getClient() {
      let params = {
        pageSize: 1,
        size: 1000,
      }
      let res = await this.$get('/iot-system/client/list', params)
      let { success, data } = res || {}
      if (success) {
        this.clientInfo = data.records.find(el => el.clientName == 'NHF');
        this.getClientList()
      }
    },


    getUserInfo() {
      this.$http.get("/nhf-app/formulaManage/myFormulaInfo").then(res => {
        let { success, data } = res;
        if (success) {
          let { userInfo, formulaCount, productCount } = data;
          this.formulaCount = formulaCount || 0;
          this.productCount = productCount || 0;
          let today = new Date();
          let todayTime = today.getTime();
          let todayDate = moment(today).format("YYYY-MM-DD");
          let src1 = new Date(todayDate + " 06:00:00").getTime();
          let src2 = new Date(todayDate + " 08:00:00").getTime();
          let src3 = new Date(todayDate + " 11:00:00").getTime();
          let src4 = new Date(todayDate + " 13:00:00").getTime();
          let src5 = new Date(todayDate + " 18:00:00").getTime();
          let name = userInfo.userName ? userInfo.userName + "，" : "";
          this.$store.commit("saveUserName", { userName: userInfo.userName });
          window.localStorage.setItem("userName", userInfo.userName);
          this.code = userInfo.code || "";
          if (todayTime < src1) {
            this.welcomeSrc = `凌晨好，${name}`;
          } else if (todayTime >= src1 && todayTime < src2) {
            this.welcomeSrc = `早上好，${name}`;
          } else if (todayTime >= src2 && todayTime < src3) {
            this.welcomeSrc = `上午好，${name}`;
          } else if (todayTime >= src3 && todayTime < src4) {
            this.welcomeSrc = `中午好，${name}`;
          } else if (todayTime >= src4 && todayTime < src5) {
            this.welcomeSrc = `下午好，${name}`;
          } else if (todayTime >= src5) {
            this.welcomeSrc = `晚上好，${name}`;
          }
        } else {
          this.$message.error("查询失败");
        }
      });
    },

    jump() {
      this.$router.go(-1)
    },

    async getFactory(arg = {}) {
      let params = {
        current: this.current,
        size: this.pageSize ? this.pageSize : this.pageSizeC,
        ...arg
      };
      const res = await this.$http.get("/nhf-app/formulaManage/myFactory", { params })
      let { success, data } = res;
      if (success) {
        let { total } = data;
        this.listC = total;
      } else {
        this.$message.error("查询失败");
      }
    }
  }
};
</script>
<style lang="scss" scoped>
.toggle-map {
  position: absolute;
  display: flex;
  align-items: center;
  justify-content: space-between;
  right: 20px;
  left: 20px;
  padding: 20px 0;
  top: 0;
  z-index: 10;
}
h3,
p {
  margin: 0;
  padding: 0;
  font-size: 13px;
}
.moMenuBox {
  .numBox {
    display: flex;
    align-items: center;
    .numLeft:after {
      content: "";
      border-right: 1px solid rgba(233, 233, 233, 1);
      display: block;
      position: absolute;
      right: 0;
      width: 1px;
      top: 10px;
      bottom: 10px;
    }
    .numContent {
      position: relative;
      text-align: center;
      padding: 0 30px;
      h3,
      p {
        margin: 0;
        padding: 0;
        font-size: 13px;
      }
      h3 {
        font-size: 28px;
        color: #444;
        font-weight: 800;
      }
    }
  }
  width: 100%;
  .userInfoBox {
    position: relative;
    background-color: #fff;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 10px 20px;
    img {
      width: 44px;
      height: 44px;
      margin-right: 10px;
    }
  }
  .tips {
    display: flex;
    align-items: center;
    h3 {
      font-size: 20px;
    }
    p {
      font-size: 16px;
    }
  }

  .tableBox {
    margin: 20px;
  }
}

.nv {
  a{
    color: #333;
  }
  a:hover {
    color: #1677ff !important;
  }
}
</style>

